// Defines the standard Yes/No choices for boolean fields.
export const YES_NO_CHOICES = [
  { value: true, name: "Yes" },
  { value: false, name: "No" },
];

// Options for the number of falls.
export const FALLS_COUNT_OPTIONS = [
  { value: "1", name: "1" },
  { value: "2", name: "2" },
  { value: "3", name: "3" },
  { value: "4", name: "4" },
  { value: "5-9", name: "5-9" },
  { value: "10+", name: "10+" },
];

// Options for the medication multi-select field.
export const MEDICATION_OPTIONS = [
  { value: "Sedative", label: "Sedative" },
  { value: "Anti-depressant", label: "Anti-depressant" },
  { value: "Topical eye medication", label: "Topical eye medication" },
  { value: "Diuretics", label: "Diuretics" },
  { value: "Blood pressure tablets", label: "Blood pressure tablets" },
  { value: "Other (record below)", label: "Other (record below)" },
];

// Options for the neurological disorder multi-select field.
export const NEUROLOGICAL_DISORDER_OPTIONS = [
  { value: "Stroke", label: "Stroke" },
  { value: "Parkinsons", label: "Parkinsons" },
  { value: "Dementia", label: "Dementia" },
  { value: "Epilepsy", label: "Epilepsy" },
  { value: "Tinnitus", label: "Tinnitus" },
  { value: "Other (please record)", label: "Other (please record)" },
];

// Defines the initial state for the form.
export const initialFormData = {
  care_plan: "",
  has_fallen_in_last_12_months: null,
  fallen_how_many_times: "",
  is_dizzy_or_lightheaded: null,
  dizzy_lightheaded_comment: "",
  taking_more_than_4_medications: null,
  medications_list: [],
  medication_comment: "",
  has_neurological_disorder: null,
  neurological_disorders: [],
  neurological_disorder_comment: "",
  is_agitated_or_confused: null,
  agitated_or_confused_comment: "",
  alcohol_intake_increases_risk: null,
  alcohol_intake_comment: "",
  is_eyesight_impaired: null,
  eyesight_impaired_comment: "",
  has_incontinence_or_urgency: null,
  incontinence_or_urgency_comment: "",
  has_trips_or_hazards_at_home: null,
  trips_or_hazards_comment: "",
  has_difficulty_getting_up: null,
  difficulty_getting_up_comment: "",
  has_previous_fractures_or_osteoporosis: null,
  previous_fractures_comment: "",
  has_worries_about_falling: null,
  worries_about_falling_comment: "",
  any_other_comments: null,
  other_comments_text: "",
};

export const fallsRiskLevels = [
  {
    label: "Low Chance of Falling",
    scoreRange: "0-3",
    description: "Low risk of falls identified. Continue standard monitoring.",
  },
  {
    label: "Medium Chance of Falling",
    scoreRange: "4-7",
    description:
      "Medium risk of falls. Consider implementing preventative measures.",
  },
  {
    label: "High Chance of Falling",
    scoreRange: "7+",
    description:
      "High risk of falls. A detailed falls prevention plan is strongly recommended.",
  },
];
